import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/v2-components/ui/accordion";
import { useTrans } from "@/utils/useTrans";
import ComponentErrorBoundary from "@/v2-components/pages/ComponentErrorBoundary";

const FAQ_KEYS = [
  { qKey: "live_faq_q_1", aKey: "live_faq_a_1" },
  { qKey: "live_faq_q_2", aKey: "live_faq_a_2" },
  { qKey: "live_faq_q_3", aKey: "live_faq_a_3" },
  { qKey: "live_faq_q_4", aKey: "live_faq_a_4" },
  { qKey: "live_faq_q_5", aKey: "live_faq_a_5" },
  { qKey: "live_faq_q_6", aKey: "live_faq_a_6" },
  { qKey: "live_faq_q_7", aKey: "live_faq_a_7" },
] as const;

function ChevronDownIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6 9L12 15L18 9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function LiveFaqSection() {
  const { t } = useTrans(["software"]);

  return (
    <ComponentErrorBoundary>
      <section className="w-full bg-white pb-[64px]">
        <div className="mx-auto w-full max-w-[1440px] px-4">
          <div className="flex flex-col gap-8 lg:flex-row lg:gap-6">
            {/* 왼쪽 */}
            <div className="flex flex-col items-center gap-3 text-center lg:w-[540px] lg:shrink-0 lg:items-start lg:text-left">
              <span className="inline-flex h-10 items-center rounded-full bg-blue-10 px-4">
                <span className="text-xs font-600 text-blue-60">FAQ</span>
              </span>
              <h2 className="text-2xl font-400 text-coolgray-90 lg:text-[32px]">
                {t("live_faq_heading")}
              </h2>
              <p className="whitespace-pre-line text-sm font-400 text-coolgray-70">
                {t("live_faq_desc")}
              </p>
            </div>

            {/* 오른쪽: Accordion */}
            <Accordion type="single" collapsible className="flex-1">
              {FAQ_KEYS.map((item, i) => (
                <AccordionItem key={i} value={`item-${i}`}>
                  <AccordionTrigger size="lg" className="text-sm">
                    <span className="flex-1 text-left">{t(item.qKey)}</span>
                    <ChevronDownIcon className="size-6 shrink-0" />
                  </AccordionTrigger>
                  <AccordionContent className="px-4 py-5">
                    <p className="whitespace-pre-line text-sm font-400 leading-relaxed text-coolgray-90">
                      {t(item.aKey)}
                    </p>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </ComponentErrorBoundary>
  );
}
